import React from "react";

export const Image2 = ({ title2, largeImage2, smallImage2 }) => {
  return (
    <div className="portfolio-item">
      <div className="hover-bg">
        {" "}
        <a href={largeImage2} title2={title2} data-lightbox-gallery="gallery2">
          <div className="hover-text">
            <h4>{title2}</h4>
          </div>
          <img src={smallImage2} className="img-responsive" alt={title2} />{" "}
        </a>{" "}
        
      </div>
    </div>
    
  );
};
